import { render, staticRenderFns } from "./UiSnackbar.vue?vue&type=template&id=29050a6f"
import script from "./UiSnackbar.vue?vue&type=script&lang=js"
export * from "./UiSnackbar.vue?vue&type=script&lang=js"
import style0 from "./UiSnackbar.vue?vue&type=style&index=0&id=29050a6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports